export default {
      id: "arrow-up-right-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg/sprite.svg#arrow-up-right",
      toString: function () {
        return this.url;
      }
    }